import * as React from 'react';
export const guideSvg = React.forwardRef(function guideSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M0 2.75C0 1.784.784 1 1.75 1H5.5c1.005 0 1.904.456 2.5 1.173A3.243 3.243 0 0 1 10.5 1h3.75c.966 0 1.75.784 1.75 1.75v10.5A1.75 1.75 0 0 1 14.25 15H1.75A1.75 1.75 0 0 1 0 13.25V2.75ZM7.25 13.5V4.25A1.75 1.75 0 0 0 5.5 2.5H1.75a.25.25 0 0 0-.25.25v10.5c0 .138.112.25.25.25h5.5Zm1.5 0h5.5a.25.25 0 0 0 .25-.25V2.75a.25.25 0 0 0-.25-.25h-1.754v3.75a.75.75 0 0 1-1.5 0V2.5H10.5a1.75 1.75 0 0 0-1.75 1.75v9.25Z',
    }),
  );
});
guideSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var guide = {
  category: 'icon',
  colorable: true,
  name: 'guide',
  svg: guideSvg,
};
